// @core/api/endpoints/product/set_product_category.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  SetProductCategoryRequest,
} from '../../../types/product';

const BASE_PATH = '/product';

/**
 * Assign product to category
 * Adds a product to a category. A product can belong to multiple categories.
 */
export async function SetProductCategory(
  product_id: string,
  data: SetProductCategoryRequest,
  options?: RequestOptions
): Promise<Response> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/products/:product_id/categories`;
  requestPath = requestPath.replace(':product_id', encodeURIComponent(product_id));
  const requestOptions = options;
  return client.post<Response>(requestPath, data, requestOptions);
}
